/** Словари сообщений от игроков: типы и состояния разбора. */
import { Tag } from "antd";
import type { ReactNode } from "react";
import { createElement } from "react";

export const FEEDBACK_KINDS = [
  { value: "FEEDBACK_KIND_BUG", label: "Ошибка" },
  { value: "FEEDBACK_KIND_PHOTO", label: "Проблема с фото" },
  { value: "FEEDBACK_KIND_QUEST", label: "Проблема с квестом" },
  { value: "FEEDBACK_KIND_IDEA", label: "Пожелание" },
  { value: "FEEDBACK_KIND_OTHER", label: "Другое" },
];

export const FEEDBACK_STATUSES = [
  { value: "FEEDBACK_STATUS_NEW", label: "Ждёт ответа" },
  { value: "FEEDBACK_STATUS_ANSWERED", label: "Отвечено" },
  { value: "FEEDBACK_STATUS_CLOSED", label: "Закрыто" },
];

export function kindLabel(kind?: string): string {
  return FEEDBACK_KINDS.find((item) => item.value === kind)?.label ?? "—";
}

export function statusLabel(status?: string): string {
  return FEEDBACK_STATUSES.find((item) => item.value === status)?.label ?? "—";
}

/** Цвет статуса: новые должны бросаться в глаза, закрытые — не мешать. */
export function statusTag(status?: string): ReactNode {
  const color =
    status === "FEEDBACK_STATUS_NEW"
      ? "gold"
      : status === "FEEDBACK_STATUS_ANSWERED"
        ? "green"
        : undefined;
  return createElement(Tag, { color }, statusLabel(status));
}
